/**
 * Common Parking Detail Modal Component
 *
 * It includes a close button and integrates `ParkingDetailViewCommon` to show relevant parking information.
 * @param {Object} props - Props containing route, navigation, FontAwesomeIcon, and iconSize.
 */
import React from "react";
import { View, StyleSheet, TouchableOpacity } from "react-native";
import ParkingDetailViewCommon from "../../views/Parking/DetailsView/ParkingDetailViewCommon";
import { COLORS, STRINGS } from "../../constants";
import { faCircleXmark } from "@fortawesome/free-solid-svg-icons";

const ParkingDetailModalCommon = ({ route, navigation, FontAwesomeIcon, closeBtnSize, iconSize }) => {
  const { index } = route.params;

  return (
    <View style={styles.modalContainer}>
      {/* Close Button */}
      <TouchableOpacity
        accessibilityLabel={`${STRINGS.close} ${STRINGS.parkingDetails}`}
        onPress={() => navigation.goBack()}
        style={styles.closeButton}
      >
        <FontAwesomeIcon icon={faCircleXmark} size={closeBtnSize} color={COLORS.border} />
      </TouchableOpacity>

      {/* Call Parking Details Component */}
      <ParkingDetailViewCommon route={{ params: { index } }} FontAwesomeIcon={FontAwesomeIcon} iconSize={iconSize} />
    </View>
  );
};

const styles = StyleSheet.create({
  modalContainer: {
    flex: 1,
    backgroundColor: COLORS.textLight,
    padding: 20,
  },
  closeButton: {
    alignSelf: "flex-end",
    padding: 16,
    paddingRight: 0,
  },
});

export default ParkingDetailModalCommon;
